import { APIHelper } from '@/services/axios';

const getUserSchedules = user_rut =>
  APIHelper.get(`/user/appointments?contact_rut=${user_rut}`);

const sendSchedule = data => APIHelper.post('/appointments', data);

const deleteAppointment = (reservation_code, data) =>
  APIHelper.post(`/appointments/${reservation_code}`, data);

export { getUserSchedules, sendSchedule, deleteAppointment };
